export default __webpack_public_path__ + "static/media/logo.947155e5.svg";